import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "15 12 12 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 17.333h-.75V15.81c0-2.103-1.68-3.81-3.75-3.81-2.07 0-3.75 1.707-3.75 3.81v1.523h-.75c-.825 0-1.5.686-1.5 1.524v7.62c0 .837.675 1.523 1.5 1.523h9c.825 0 1.5-.686 1.5-1.524v-7.619c0-.838-.675-1.524-1.5-1.524zM21 24.191c-.825 0-1.5-.686-1.5-1.524s.675-1.524 1.5-1.524 1.5.686 1.5 1.524-.675 1.523-1.5 1.523zm2.325-6.858h-4.65V15.81c0-1.303 1.043-2.362 2.325-2.362 1.282 0 2.325 1.059 2.325 2.362v1.523z",
    fill: "currentColor"
  })));
}

export { SvgLock as ReactComponent };
